import request from '@/utils/request'
import { get_url_deal } from '@/utils/commons'

export function get_recruit_data_page(data) {
  const url = get_url_deal('recruit/selectRecruitPage.json', data)
  return request.get(url)
}

/* 获取筛选信息*/
export function get_recruit_info() {
  const url = 'recruit/selectRecruitInfo.json'
  return request.get(url)
}
